function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { dataLayer } from '@finect/front-gtm';
import { getLoggedUser } from '@finect/front-core/User';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { getURLWithQueryString } from '@finect/front-utils/getURLWithQueryString';
import { PillModal } from '../../Pills';
var pillsBaseURL = getSuperPartnerBaseURL();
export function setProductRequest(product) {
  var commercialization = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var flow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: 'SET_PRODUCT_REQUEST',
    params: {
      product: product,
      commercialization: commercialization,
      flow: flow
    }
  };
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    productRequest: state.products.productRequest
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      setProductRequest: setProductRequest,
      getLoggedUser: getLoggedUser
    }, dispatch)
  };
};
var getPillUrl = function getPillUrl(productRequest, consumer) {
  var product = productRequest.product,
    commercialization = productRequest.commercialization,
    flow = productRequest.flow;
  var directPill = product.entity.commercializations.find(function (comm) {
    return comm.affiliate.name === 'PILL';
  });
  if (directPill) {
    return directPill.affiliate.link;
  }
  if (commercialization && commercialization.organization.alias === 'ironia') {
    var pillUrl = flow === 'account' ? "".concat(pillsBaseURL, "/pills/es_ES/").concat(consumer, "/default/ironia/steps/isIroniaAccount?isIroniaAccount=false") : flow === 'link' ? "".concat(pillsBaseURL, "/pills/es_ES/").concat(consumer, "/default/ironia/steps/isIroniaAccount?isIroniaAccount=true") : "".concat(pillsBaseURL, "/pills/es_ES/").concat(consumer, "/default/ironia-comprar/steps/amountToInvest?productCommercialRelationship=").concat(commercialization.id);
    return pillUrl;
  }
  return getURLWithQueryString("".concat(pillsBaseURL, "/pills/es_ES/").concat(consumer, "/default/products-leads/steps/productConsidered"), {
    productConsidered: productRequest.product.entity.id,
    distributor: commercialization ? commercialization.organization.alias : undefined
  });
};
var ProductRequestModal = function (_React$Component) {
  _inherits(ProductRequestModal, _React$Component);
  var _super = _createSuper(ProductRequestModal);
  function ProductRequestModal() {
    var _this;
    _classCallCheck(this, ProductRequestModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleCloseModal", function () {
      _this.props.actions.setProductRequest(null);
    });
    _defineProperty(_assertThisInitialized(_this), "handleResultsPage", function (event) {
      if (event.href.indexOf('/indexa') > 0) {
        window.location.replace(event.href);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleLogin", function () {
      _this.props.actions.getLoggedUser();
      window.postMessage({
        status: 'loggedIn'
      });
    });
    return _this;
  }
  _createClass(ProductRequestModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$productRe = this.props.productRequest,
        product = _this$props$productRe.product,
        commercialization = _this$props$productRe.commercialization;
      if (!product) return false;
      if (product && !prevProps.productRequest.product) {
        dataLayer({
          id: 'ProductLeads',
          type: 'addToCart',
          params: {
            model: product,
            commercialization: product.entity.commercializations.length === 1 ? product.entity.commercializations[0] : commercialization
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var product = this.props.productRequest.product;
      var _this$props$theme$par = this.props.theme.partner.consumer,
        consumer = _this$props$theme$par === void 0 ? 'finect' : _this$props$theme$par;
      if (!product) return null;
      var pillUrl = getPillUrl(this.props.productRequest, consumer);
      return React.createElement(PillModal, {
        onResultsPage: this.handleResultsPage,
        onClose: this.handleCloseModal,
        onLogin: this.handleLogin,
        pill: pillUrl
      });
    }
  }]);
  return ProductRequestModal;
}(React.Component);
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(ProductRequestModal));